<template>
  <base-dialog-component
    :showInfoIcon="false"
    :showClose="true"
    :open="open"
    :title="$t(title)"
    :body="$t(body)"
    :slideBody.sync="slideBody"
    bodyType="carousel"
    :buttonR="$t(buttonR)"
    @callBackButtonR="buttonClick"
    @closeDialog="closeClick"
    height="auto"
    width="50vw"
    top="50%"
    left="50%"
    :center="true"
    paddingText="0 0 10px 0"
  ></base-dialog-component>
</template>
<script>
import baseComponent from "./baseComponent.vue";

export default {
  name: "preTestComponent",
  components: {
    baseDialogComponent: baseComponent,
  },
  data() {
    return {
      open: false,
      slideBody: 0,
      resolveDialog: null,
      title: null,
      body: null,
      buttonR: null,
    };
  },
  beforeMount() {
    this.$root.$on("startPreTest", this.startPreTest);
  },
  beforeDestroy() {
    this.$root.$off("startPreTest", this.startPreTest);
  },
  methods: {
    startPreTest({ resolve, title, body, buttonR }) {
      this.resolveDialog = resolve;
      this.title = title;
      this.body = body;
      this.buttonR = buttonR;
      this.open = true;
    },
    buttonClick() {
      this.resolveDialog(true);
      this.open = false;
    },
    closeClick() {
      this.resolveDialog(false);
      this.open = false;
    },
  },
};
</script>
